import type { ReactElement } from "react";
import { KeyValuePanel } from "~/components/Common/KeyValuePanel";

export function ParamsTab(): ReactElement {
    return <KeyValuePanel panelName="Params" />;
}
